export default {
  namespaced: true,

  state: {
    matrix: [],
    validationPreview: null,
    validationErrors: [],
    validationWarnings: [],
  },

  mutations: {
    setMatrix(state, data) {
      state.matrix = data || []
    },
    setValidationPreview(state, data) {
      state.validationPreview = data
      state.validationErrors = (data && data.errors) || []
      state.validationWarnings = (data && data.warnings) || []
    },
    clearValidation(state) {
      state.validationPreview = null
      state.validationErrors = []
      state.validationWarnings = []
    },
  },

  actions: {
    async fetchMatrix({ commit }) {
      const { data } = await this.$api.get('questionnaire-option-scores')
      commit('setMatrix', data.data)
      return data.data
    },

    async validateUpload({ commit }, formData) {
      commit('clearValidation')
      const { data } = await this.$api.post(
        'questionnaire-option-scores/validate-import',
        formData
      )
      commit('setValidationPreview', data.data)
      return data.data
    },

    async applyUpload({ commit, dispatch }, formData) {
      const { data } = await this.$api.post(
        'questionnaire-option-scores/import',
        formData
      )
      commit('clearValidation')
      await dispatch('fetchMatrix')
      return data
    },
  },
}
